export enum KeyShortcut {
  ToggleMute = 'm',
  ToggleVideo = 'v',
  TogglePictureInPicture = 'p',
  ToggleStatus = 's',
  ToggleAway = 'q',
  ActionBar = 'ctrl+k,command+k',
  Undo = 'ctrl+z,command+z',
}
